module.exports = __webpack_public_path__ + "img/download_material.0b245fd6.svg";